import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

type Props = React.PropsWithChildren;

export const Title: React.FC<Props> = (props) => {
  return <AlertDialog.Title asChild>{props.children}</AlertDialog.Title>;
};
